const marksItems = ['marksPremiumModule', 'catPremiumModule', 'upscPremiumModule'];

export default marksItems;
